import {Component, Input, OnInit} from '@angular/core';
import {AffectionTableListeMetierService} from './affection-table.liste.metier.service';
import {Autowired} from '@angular-ru/autowired';
import {SgiListLayoutComponent} from '@shared/behaviors/list-layout/sgi/sgi-list-layout.component';
import {CommonUtilities} from '@app/core/utilities/common.utilities';

@Component({
  selector: 'app-affection-table-liste',
  templateUrl: './affection-table.liste.component.html'
})

export class AffectionTableListeComponent extends SgiListLayoutComponent implements OnInit {
  @Autowired() recuperationListeDonneesMetier: AffectionTableListeMetierService;

  @Input('currentDataUser') currentDataUser: any;
  hasDetails: boolean;

  constructor() {
    super();
    this.cols = [
      {field: 'codeAffection', header: 'Code Affection'},
      // { field: 'libelleAffection', header: 'Libellé' },
    ];

    this.tableActions = [];
  }

  ngOnInit(): void {
    if (this.currentDataUser) {
      this.hasDetails = this.currentDataUser.affectionPrescriptionLier;
      this.recuperDonnees();
    }
  }

  /**
   * Définition des arguments
   */
  defineArgs(): void {
    super.defineArgs();
    const arg = {...this.args, currentDataUser: this.currentDataUser};
    this.args = {...arg};
  }

  /**
   * => return true, si le tableau est vide
   */
  isEmptyObject(obj) {
    return CommonUtilities.isEmptyObject(obj);
  }

  /**
   * fonction de retour de affectionPrescriptionLier de l'utilisateur courant
   * => return boolean
   */
  getAffectionPrescriptionLier() {
    if (this.currentRow && this.currentRow.affectionPrescriptionLier) {

      return this.currentRow.affectionPrescriptionLier;
    }
    return false;
  }

}
